import React, { useState } from 'react';
import { fetchEmergencyProducedChildMaterial } from '../../apis/calls';
import {
  EmergencyAgsn,
  EmergencyAgsnConflict,
  TabbedViewWithDateSelect,
} from '../../components';
import { useAjaxCallbackWithIntervals } from '../../hooks';
import { usePlantAndLinesStore } from '../../providers/PlantAndLinesStore/PlantAndLinesStore';
import PropTypes from 'prop-types';

const EmergencyAgsnView = ({ aggregate }) => {
  const [plant] = usePlantAndLinesStore().plantState;
  const [eAgsnCount, setEAgsnCount] = useState(0);
  const [eAgsnConflictCount, setEAgsnConflictCount] = useState(0);
  const [handleEAgsnEdit, setEAgsnEdit] = useState(false);
  const [rowsDataForEAgsn, setRowsDataForEAgsn] = useState({
    loading: false,
    data: [],
    filteredData: [],
  });
  const [rowsDataForEAgsnConflict, setRowsDataForEAgsnConflict] = useState({
    loading: false,
    data: [],
    filteredData: [],
  });
  const handleEAgsnCountChange = count => {
    setEAgsnCount(count);
  };
  const handleEAgsnConflictCountChange = count => {
    setEAgsnConflictCount(count);
  };
  const filterEAgsnRowsData = rowsData => {
    return rowsData.filter(data => {
      return (
        data.lineId
      );
    });
  };
  const filterEAgsnConflictRowsData = rowsData => {
    return rowsData.filter(data => {
      return (
        (data.lineId === null || data.lineId === undefined) &&
        (data.plannedProductionDate === null ||
          data.plannedProductionDate === undefined)
      );
    });
  };

  const loadPlannedEmergencyAgsn = async () => {
    try {
      if (plant.value) {
        setRowsDataForEAgsn(prevState => ({ ...prevState, loading: true }));
        const aggregateShopName = aggregate;
        const response = await fetchEmergencyProducedChildMaterial(
          plant.value,
          aggregateShopName,
        );
        const emergencyAgsnRowData = filterEAgsnRowsData(response.data);

        const sortedEmergencyAgsnRowData = emergencyAgsnRowData.sort((a, b) => {
          const dateA = new Date(a.parentPlannedProductionDate);
          const dateB = new Date(b.parentPlannedProductionDate);
          const dateDiff = dateA - dateB;
          if (dateDiff !== 0) return dateDiff;
          if (a.parentAsn < b.parentAsn) return -1;
          if (a.parentAsn > b.parentAsn) return 1;
          return 0;
        });


        if (sortedEmergencyAgsnRowData.length <= 0) {
          setRowsDataForEAgsn({
            data: [],
            loading: false,
          });
        } else {
          handleEAgsnCountChange(sortedEmergencyAgsnRowData.length);

          setRowsDataForEAgsn({
            data: sortedEmergencyAgsnRowData,
            filteredData: sortedEmergencyAgsnRowData,
            loading: false,
          });
        }

        const emergencyAgsnConflictRowData = filterEAgsnConflictRowsData(
          response.data,
        );
        handleEAgsnConflictCountChange(emergencyAgsnConflictRowData.length);
        setRowsDataForEAgsnConflict({
          data: emergencyAgsnConflictRowData,
          filteredData: emergencyAgsnConflictRowData,
          loading: false,
        });
      }
    } catch (err) {
      console.error('failed to load Emergency Agsn');
      setRowsDataForEAgsn({
        data: [],
        loading: false,
      });
      setRowsDataForEAgsnConflict({
        data: [],
        loading: false,
      });
    }
  };

  const lastRefreshedDateForEAgsn = useAjaxCallbackWithIntervals(
    rowsDataForEAgsn.loading,
    handleEAgsnEdit,
    loadPlannedEmergencyAgsn,
    aggregate,
    plant.value,
  );
  return (
    <TabbedViewWithDateSelect
      tabs={[
        {
          label: 'eAgSN',
          title: 'eAgSN',
          count: eAgsnCount,
          component: EmergencyAgsn,
          props: {
            aggregate,
            rowsDataForEAgsn,
            lastRefreshedDate: lastRefreshedDateForEAgsn,
            setEAgsnEdit,
            loadPlannedEmergencyAgsn,
          },
        },
        {
          label: 'Conflict',
          title: 'Conflict',
          count: eAgsnConflictCount,
          countColor: 'red',
          component: EmergencyAgsnConflict,
          props: {
            aggregate,
            rowsDataForEAgsnConflict,
            setRowsDataForEAgsnConflict,
            handleCountChange: handleEAgsnConflictCountChange,
            lastRefreshedDate: lastRefreshedDateForEAgsn,
            isEAgnEdit: handleEAgsnEdit,
            setEAgsnEdit,
            loadPlannedEmergencyAgsn,
          },
        },
      ]}
      pageTitle=""
    />
  );
};
EmergencyAgsnView.propTypes = {
  aggregate: PropTypes.string.isRequired,
};
export default EmergencyAgsnView;
